import { render } from "./stats.vue?vue&type=template&id=2bd20b52&scoped=true"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"

import "./stats.vue?vue&type=style&index=0&id=2bd20b52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd20b52"]])

export default __exports__